import React, { createContext, useState } from "react"

const ReportContext = createContext()

function ReportProvider( { children } ) {
  const [ report_data , setReportData ] = useState( [] );
  const [ report_name , setReportName ] = useState( '' );
  const [ is_loading  , setIsLoading  ] = useState( false );

  const values = { 
    report_data , setReportData ,
    report_name , setReportName ,
    is_loading  , setIsLoading  ,
  };

  return (
    <ReportContext.Provider value={ values }>
      {children}
    </ReportContext.Provider>
  );
};

export { ReportContext, ReportProvider };